import { RequestServer } from "../../../utils/services";
import { APIRoutes } from "../../../constants";
import { CompanyInfo, profileElement } from ".";

interface CompanyInfoExpertsResponse {
    experts: profileElement[];
    totalResult:number;
    totalPages:number;
    page:number;
    limit:number;
}

export const fetchCompanyExperts = async (companyData: CompanyInfo , rowsPerPage:number , page:number): Promise<CompanyInfoExpertsResponse> => {
  try {
    const url = `${APIRoutes.COMPANY_INFO_EXPERTS}?companyId=${companyData.id}&page=${page}&limit=${rowsPerPage}`;
    const response = await RequestServer(url , "GET");
    if (response?.success) {
      return response?.data;
    }
    throw new Error("ERROR FETCHING COMPANY EXPERTS");
  } catch (error: any) {
    console.log(error);
    return {experts:[],totalResult:0,totalPages:0 , page:0 , limit:0};
  }
};